import { useState } from "react";
import { Bell, Check, Info, ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ReminderConfig from "../../components/reminders/ReminderConfig";

export default function RemindersSettings() {
  const { t } = useTranslation();
  const [saved, setSaved] = useState(false);

  return (
    <div className="space-y-6">
      {/* Page header with back link */}
      <div className="flex items-center gap-4">
        <Link
          to="/settings"
          className="flex items-center justify-center h-8 w-8 rounded-lg border border-border hover:bg-accent transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
        </Link>
        <div className="flex-1">
          <h1 className="text-2xl font-semibold">{t("reminders.title")}</h1>
          <p className="text-muted-foreground">{t("reminders.description")}</p>
        </div>
        {saved && (
          <div className="flex items-center gap-2 text-sm text-green-600 dark:text-green-400">
            <Check className="h-4 w-4" />
            <span>{t("common.saved")}</span>
          </div>
        )}
      </div>

      <div className="bg-card rounded-xl shadow-sm border p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Bell className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">{t("reminders.title")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("reminders.description")}
            </p>
          </div>
        </div>

        <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg mb-6">
          <div className="flex gap-3">
            <div className="shrink-0">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10">
                <Info className="w-4 h-4 text-primary" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-foreground">
                {t("common.info")}
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t("reminders.howRemindersWork")}
              </p>
            </div>
          </div>
        </div>

        <ReminderConfig
          isOrgDefault
          onSave={() => {
            setSaved(true);
            setTimeout(() => setSaved(false), 3000);
          }}
        />
      </div>
    </div>
  );
}
